'use client';

import { Woonstad_Foundation_Portfolio_Api_Models_WRM_IndexedComplex } from '@woonstad/api-client-stadswonen-aanbod';
import { Map, Typography } from '@woonstad/design-system';

import { getDictionary } from '../../../../consts/dictionaries/get-dictionary';
import { SITES } from '../../../../consts/types';

type Props = {
  complex?: Woonstad_Foundation_Portfolio_Api_Models_WRM_IndexedComplex;
  accessToken?: string;
};

export const ComplexLocation = ({
complex,
accessToken
}: Props) => {
  const dict = getDictionary(SITES.Stadswonen);
  const address = complex?.Address;
  const location = address?.Location;
  const hasLocation = accessToken && location?.lon && location?.lat;

  return (
    <section
      className="space-y-4"
      aria-label={dict['Locatie']}
    >
      <Typography
        variant="title-block"
        textColorClassname="text-content-header"
      >
        {dict['Locatie']}
      </Typography>
      {hasLocation && (
        <div className="h-[20em] w-full">
          <Map
            location={{
              lon: location.lon as number,
              lat: location.lat as number,
            }}
            renderMarkersAs="location"
            defaultLocation={{
              longitude: 4.46280533777813,
              latitude: 51.9151761415949,
            }}
            accessToken={accessToken}
            zoomText={{
              ctrlMessage: dict['Gebruik ctrl + scroll om op de kaart in te zoomen'],
              cmdMessage: dict['Gebruik ⌘ + scroll om op de kaart in te zoomen'],
              touchPan: dict['Gebruik twee vingers om de kaart te verplaatsen'],
              zoomIn: dict['Zoom in'],
              zoomOut: dict['Zoom uit'],
            }}
          />
        </div>
      )}
      <div>
        <Typography
          variant="content-body-bold"
          textColorClassname="text-base-primary-on-light"
        >
          {dict['Adres']}
        </Typography>
        <Typography
          variant="content-body"
          textColorClassname="text-base-primary-on-light"
        >
          {`${address?.Street} ${address?.Number} ${address?.Addition}`}
        </Typography>
      </div>
      <div>
        <Typography
          variant="content-body-bold"
          textColorClassname="text-base-primary-on-light"
        >
          {dict['Wijk']}
        </Typography>
        <Typography
          variant="content-body"
          textColorClassname="text-base-primary-on-light"
        >
          {`${address?.District} (${address?.Region})`}
        </Typography>
      </div>
    </section>
  );
};
